import { Navigate, useLocation } from 'react-router-dom';
import RouteLoadingFallback from '@/components/shared/RouteLoadingFallback';
import { useAllEntitlements } from '@/contexts/EntitlementsContext';
import { getFeatureKeyForRoute } from '@/lib/featureFlags';

export function LaunchGate({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { hasFeature, isSuperAdmin, isLoading } = useAllEntitlements();

  // Super admin sees everything
  if (isSuperAdmin) return <>{children}</>;

  // Admin override via localStorage (for development, screenshots, demos)
  if (
    typeof window !== 'undefined' &&
    localStorage.getItem('venueintel-admin-override') === 'true'
  ) {
    return <>{children}</>;
  }

  // Wait for entitlements to load
  if (isLoading) return <RouteLoadingFallback />;

  // Find the feature key for this route
  const featureKey = getFeatureKeyForRoute(location.pathname);

  // No feature key mapped = ungated (account pages, auth, getting-started, onboarding)
  if (!featureKey) return <>{children}</>;

  // Check entitlement
  if (!hasFeature(featureKey)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
